export default "__VITE_ASSET__CVQGNTt6__"